module.exports = __webpack_public_path__ + "img/leeb-balkone-mitarbeiter.bfde7e8d.jpg";